<template>
    <div class="pik_calendar">
        <div class="arrows" @click='DateJump(false)' :class='{grey:isMin()}'>
            <i class="iconfont icon-arrow-left"></i>
        </div>
        <div class="calendar" @click="openPick">
            {{value | dateF}}
        </div>
        <div class="arrows" @click='DateJump(true)'>
            <i class="iconfont icon-arrow-right" :class='{grey:isMax()}'></i>
        </div>
        <mt-datetime-picker ref="picker" @confirm="handleConfirm" type="date" :startDate="minDate" :endDate="maxDate" v-model="value">
        </mt-datetime-picker>
    </div>
</template>
<script>
import moment from "moment";
import { Toast } from "mint-ui";
export default {
  name: "datepik",
  data() {
    return {
      value:
        this.defaultValue != ""
          ? this.defaultValue
          : moment().format("YYYY-MM-DD"),
      minDate: moment(moment().format("YYYY-MM-DD"))
        .add(this.minMonth, "M")
        .toDate(),
      maxDate: moment(moment().format("YYYY-MM-DD"))
        .add(this.maxMonth, "M")
        .toDate()
    };
  },
  props: {
    step: {
      type: String,
      default: "1"
    },
    defaultValue: {
      type: String,
      default: ""
    },
    minMonth: {
      default: "-120"
    },
    maxMonth: {
      default: "120"
    },
    limit: {
      type: String,
      default: "next"
    },
    firstDay: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.limit == "next") {
      this.minDate = moment(this.value).toDate();
    } else if (this.limit == "pre") {
      this.maxDate = moment(this.value).toDate();
    }
    if(this.firstDay){
      this.minDate= moment(moment().format("YYYY-MM-DD"))
        .add(this.minMonth, "M").startOf('year')
        .toDate()
    }
  },
  methods: {
    isMin() {
      return this.minDate != null && moment(this.value) <= moment(this.minDate);
    },
    handleConfirm(d) {
      this.$emit("change", this.value);
    },
    setDate(date) {
      this.value = moment(date).format("YYYY-MM-DD");
    },
    isMax() {
      return this.maxDate != null && moment(this.value) >= moment(this.maxDate);
    },
    openPick() {
      this.$refs.picker.open();
    },
    msg(msg) {
      Toast({
        message: msg,
        position: "center",
        duration: 1000
      });
    },
    DateJump(next) {
      if (next) {
        if (this.isMax()) {
          this.msg(this.$t('controll_datepik_no_next'));
          return;
        }
      } else {
        if (this.isMin()) {
          this.msg(this.$t('controll_datepik_no_pre'));
          return;
        }
      }
      var d = moment(this.value).add(next ? this.step : -this.step, "d");
      if (next) {
        if (this.maxDate != null && d > moment(this.maxDate)) {
          d = moment(this.maxDate);
        }
      } else {
        if (this.minDate != null && d < moment(this.minDate)) {
          d = moment(this.minDate);
        }
      }
      this.value = d.format("YYYY-MM-DD");
      this.$emit("change", this.value);
    }
  },
  filters: {
    dateF(v) {
      return v != null ? moment(v).format("YYYY-MM-DD") : "";
    }
  }
};
</script>
<style lang='less'>
.pik_calendar {
  width: 4.5rem;
  height: 1.1rem;
  margin: 0 auto;
  .arrows {
    float: left;
    line-height: 1.1rem;
    text-align: center;
    color: #666;
    .iconfont {
      font-size: 0.6rem;
        line-height: 1.1rem;
    }
  }
  .calendar {
    width: 3.2rem;
    float: left;
    text-align: center;
     line-height: 1.1rem;
    font-size: 0.48rem;
  }
  .grey {
    color: #d8d8d8;
  }
}
</style>



// WEBPACK FOOTER //
// datepik.vue?5287856c